import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, List } from "utils";

import { Horloge } from "components";
import moment from "moment";
import { icons } from "constants/icons";

import { Link, NavLink } from "react-router-dom";
import { CarouselPhotos, NotificationsTv } from "components/";
import { Counter } from "components/_charts";
import { statsService } from "services";
import { Icon } from "antd";

class HomeTvPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      counts_year: [],
      counts_week: [],
    };
    this.fetchStats = this.fetchStats.bind(this);

    setInterval(function () {
      window.location.reload();
    }, 300000);
  }

  componentDidMount() {
    this.fetchStats();
  }

  fetchStats() {
    const year_begin = moment().startOf("year").format("YYYY-MM-DD");
    const week_begin = moment().startOf("week").format("YYYY-MM-DD");
    const today = moment().add(1, "day").endOf("day").format("YYYY-MM-DD");
    
    statsService
      .stats_tv("date[]=" + year_begin + "&date[]=" + today)
      .then((result) => {
        this.setState({ counts_year: result });
      })
      .catch((e) => {
        this.setState(() => {
          throw new Error(e);
        });
      });

    statsService
      .stats_tv("date[]=" + week_begin + "&date[]=" + today)
      .then((result) => {
        this.setState({ counts_week: result });
      })
      .catch((e) => {
        this.setState(() => {
          throw new Error(e);
        });
      });
  }

  render() {
    const { counts_year, counts_week } = this.state;

    return (
      <Fragment>
        <Helmet>{title("Accueil TV")}</Helmet>
        <div className="homeTv-page main-content">
          <div className="header"></div>
          <CarouselPhotos autoplay />
          <div className="notif_stat">
            <div className="notifications">
              <h2>
                <Icon type="notification" />
                Notifications
              </h2>
              <NotificationsTv />
            </div>
            <div className="statistics">
              <Horloge />
              <article>
                <h2>
                  <Icon type={icons.sse} />
                  Interventions SSE de la semaine
                </h2>
                <Counter data={counts_week.intervention_count} />
              </article>
              <article>
                <h2>
                  <Icon type={icons.sse} /> Interventions SSE de l'année
                </h2>
                <Counter data={counts_year.intervention_count} />
              </article>
              <article>
                <h2>
                  <Icon type={icons.tailgate} />
                  Tailgates de la semaine
                </h2>
                <Counter data={counts_week.tailgate_count} />
              </article>
              <article>
                <h2>
                  <Icon type={icons.tailgate} />
                  Tailgates de l'année
                </h2>
                <Counter data={counts_year.tailgate_count} />
              </article>
            </div>
          </div>
          <div className="proj_sse">
            <div className="col">
              <span className="title">Projets</span>
              <List cards={true} type="home" tv={true} className="projet" />
            </div>
            <div className="col">
              <span className="title">Interventions SSE</span>
              <List type="sse" filters={{ type_id: 2 }} cards={true} tv={true} />
            </div>
          </div>
          <div className="back">
            <NavLink to="/" exact>
              Retour a l'accueil
            </NavLink>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default HomeTvPage;
